<div
  id="nav-indicator"
  [ngStyle]="{ width: navigationBarWidthPercentage + '%', opacity: this.navigationInProgress ? 1 : 0 }"
></div>
